document.addEventListener("DOMContentLoaded", function() {
  // 1) openTab-Funktion mit Guards
  function openTab(evt, tabName) {
    if (!tabName) return;
    
    var contents = document.getElementsByClassName("myapp2-tabcontent");
    for (var i = 0; i < contents.length; i++) {
      contents[i].style.display = "none";
    }

    var links = document.getElementsByClassName("myapp2-tablinks");
    for (var j = 0; j < links.length; j++) {
      links[j].classList.remove("myapp2-active");
    }

    var target = document.getElementById(tabName);
    if (target) {
      target.style.display = "block";
    }

    if (evt && evt.currentTarget) {
      evt.currentTarget.classList.add("myapp2-active");
    }
  }

  // 2) Tab-Buttons per JS binden (statt onclick-Attribute)
  var tabButtons = document.querySelectorAll(".myapp2-tablinks");
  tabButtons.forEach(function(btn) {
    btn.addEventListener("click", function(e) {
      var tab = btn.getAttribute("data-tab");
      openTab(e, tab);
    });
  });

  // 3) Default-Tab automatisch öffnen
  var defaultBtn = document.getElementById("defaultOpen");
  if (defaultBtn) {
    var firstTab = defaultBtn.getAttribute("data-tab");
    openTab(null, firstTab);
    defaultBtn.classList.add("myapp2-active");
  }

  // 4) Accordion
  var accItems = document.querySelectorAll(".myapp2-accordion, .myapp2-accordion-1, .myapp2-accordion-2");
  accItems.forEach(function(el) {
    el.addEventListener("click", function() {
      var panel = this.nextElementSibling;
      var icon = this.querySelector(".myapp2-accordion-icon");
      if (!panel || !icon) return;

      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        panel.classList.remove("myapp2-panel-active");
        icon.style.transform = "rotate(0deg)";
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
        panel.classList.add("myapp2-panel-active");
        icon.style.transform = "rotate(45deg)";
      }
    });
  });
});
